/* Mi perfil → Seguridad (cambiar contraseña del portal). */
import { useState } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { showToast } from '@/components/layout/Toast'

export default function PerfilSeguridad() {
  const { updatePassword } = useAuth()
  const [pass1, setPass1] = useState('')
  const [pass2, setPass2] = useState('')
  const [saving, setSaving] = useState(false)

  async function cambiar() {
    if (pass1.length < 8) { showToast('La contraseña debe tener al menos 8 caracteres', 'error'); return }
    if (pass1 !== pass2) { showToast('Las contraseñas no coinciden', 'error'); return }
    setSaving(true)
    try {
      await updatePassword(pass1)
      setPass1(''); setPass2('')
      showToast('Contraseña actualizada', 'success')
    } catch (err: any) {
      showToast(err.message || 'No se pudo actualizar la contraseña', 'error')
    } finally { setSaving(false) }
  }

  return (
    <div className="card pp-card">
      <div className="pp-card__head">
        <div>
          <h3 className="pp-card__titulo">Cambiar contraseña</h3>
          <p className="pp-card__sub">Actualiza tu clave de acceso al panel.</p>
        </div>
      </div>
      <div className="pp-campos-apilados">
        <div className="form-group">
          <label className="form-label">Nueva contraseña</label>
          <input className="form-input" type="password" value={pass1} onChange={e => setPass1(e.target.value)} placeholder="Mínimo 8 caracteres" autoComplete="new-password" />
        </div>
        <div className="form-group">
          <label className="form-label">Repite la contraseña</label>
          <input className="form-input" type="password" value={pass2} onChange={e => setPass2(e.target.value)} autoComplete="new-password" />
        </div>
      </div>
      <div className="pp-card__pie">
        <button className="btn btn-secondary" onClick={cambiar} disabled={saving || !pass1 || !pass2}>
          {saving ? 'Actualizando…' : 'Actualizar contraseña'}
        </button>
      </div>
    </div>
  )
}
